<template>
  <div class="role-list animated fadeIn">
    <div class="top-template animated fadeIn" v-show="done">
      <img class="img-title" src="../assets/roleList/img-title.png"/>
      <img class="img-download remove-unclick" @click="toDownLoad" src="../assets/roleList/btn-download.png"/>
      <div class="cd-template">
        <div class="avatar-parent">
          <img class="img-avatar" :class="{'roatate-animation': listenDone}" :src="nowStar.star_avatar || this.$root.myData.star_avatar" />
        </div>
        <img class="img-bar" :class="{'rotate-30-minus': listenDone}" src="../assets/roleList/cd-bar.png"/>
        <div class="avatar-cd-parent">
          <img class="img-cd" :class="{'roatate-animation': listenDone}" src="../assets/roleList/cd.png"/>
        </div>
        <waveAnimation oneclose="true" width="120px" height="120px" :play="listenDone" class="wave"/>
      </div>
    </div>

    <div class="star-list animated fadeIn" v-show="done">
      <div class="star" v-for="(li, index) in starList" :key="index">
        <div class="left">
          <img class="avatar" :src="li.star_avatar"/>
        </div>
        <div class="right" @click="startMusic(index)">
          <p class="name">{{li.star_name}}</p>
          <p class="desc">{{li.star_subtitle}}</p>
          <MusicCommon :mid="index" :ref="'musicdom' + index" :music-path="li.star_audio_mini" class="common-music" />
        </div>
      </div>
    </div>

    <div class="done-template" @click.self="listenDoneAuto = false" v-if="listenDoneAuto">
      <div class="done">
        <img class="close" @click.self="listenDoneAuto = false" src="../assets/close.png" />
        <img @click.self="listenDoneAuto = false" class="done-img remove-unclick" src="../assets/img_album_stop@2x.png"/>
        <Button @click.native="toDownLoad()"  text="下载小睡眠"></Button>
      </div>
    </div>
  </div>
</template>
<script>
import MusicCommon from '../components/music-common.vue'
import waveAnimation from '../components/waveAnimation'
import Button from '../components/Button'

export default {
  name: 'RoleList',
  data () {
    return {
      listenDoneAuto: false,
      listenDone: false,
      nowIndex: undefined,
      nowStar: {},
      done: false,
      starList: [],
      nowPage: 0,
      page: 0,
      noPage: false,
      busyPulling: false
    }
  },
  components: {
    MusicCommon,
    waveAnimation,
    Button
  },
  methods: {
    scrollFunc () {
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
      let windowHeight = window.innerHeight
      let scrollHeight = document.body.scrollHeight
      console.log('scroll', scrollTop, windowHeight, scrollHeight)
      if (scrollTop + windowHeight >= scrollHeight - 10) {
        // 上拉加载更多
        console.log('scroll')
        this.getStarsData()
      }
    },
    toDownLoad () {
      window.location.href = this.$root.downloadLink
    },
    startMusic (index) {
      for (let i = 0; i < this.starList.length; i++) {
        const dom = this.$refs['musicdom' + i][0]
        if (dom.toggle === false) {
          dom.musicPlay()
        }
      }
      if (this.nowIndex === index) {
        this.listenDone = false
        this.nowIndex = undefined
        return
      }
      this.$nextTick(() => {
        this.listenDone = true
        this.$refs['musicdom' + index][0].musicPlay()
        this.nowIndex = index
      })
      this.nowStar = this.starList[index]
    },
    getStarsData (init = false) {
      if (this.noPage || this.busyPulling) {
        return
      }
      this.busyPulling = true
      this.$axios.get('/web/v1/cosleep/sleep/star', { params: { p: this.page } }).then((res) => {
        if (res.data.status === 1) {
          this.busyPulling = false
          const data = res.data.data
          if (data.length > 0) {
            this.page += 1
            this.starList.push(...data)
            if (init) {
              this.done = true
              // this.$nextTick(() => {
              //   this.startMusic(0)
              // })
            }
          } else {
            this.noPage = true
          }
        }
      })
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollFunc)
  },
  created () {
    this.$root.showBg = true
    window.addEventListener('scroll', this.scrollFunc)
    this.getStarsData(true)
  }
}
</script>

<style  lang="scss" scoped>
  .wave {
    position: absolute;
    top: 15px;
    left:50%;
    transform: translateX(-50%);
    z-index: 1;
  }

  .star-list {
    position: relative;
    z-index: 1;
    color: #fff;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 20px;
    .star {
      width: 100%;
      // width: 325px;
      height: 90px;
      display: flex;
      background-image: url("../assets/roleList/bg_list@2x.png");
      background-size: 100% 100%;
      margin: 22px 0px;
      border-radius: 10px;
      .left {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 85px;
        .avatar {
          box-shadow: 3px 3px rgba(227, 101, 255, 1), -3px -3px rgba(63, 76, 255, 1);
          border-radius: 50%;
          width: 55px;
        }
      }
      .right {
        text-align: left;
        position: relative;
        width: 100%;
        .name {
          font-size: 15px;
          margin-top: 18px;
        }
        .desc {
          width: 180px;
          margin-top: 2px;
          font-size: 12px;
        }
        .common-music {
          z-index: 3;
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .role-list {
    flex-direction: column;
    background-attachment: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    top: 0px;
    left: 0px;
    overflow-x: hidden;
    overflow-y: scroll;
    // background-image: url("../assets/roleList/bg_dark@2x.png");
    // background-size: 110% auto;
    // background-repeat: no-repeat;
  }

  .top-template {
    z-index: 1;
    height: 174px;
    width: 360px;
    position: relative;
    margin-top: 13px;
    .img-title {
      position: absolute;
      left: 10px;
      top: 0px;
      width: 240px;
      z-index: 3;
    }
    .img-download {
      width: 70px;
      position: absolute;
      top: 104px;
      left: 130px;
      z-index: 2;
    }

    .cd-template {
      width: 150px;
      position: absolute;
      right: 10px;
      top: 20px;
      .img-cd {
        width: 150px;
      }
      .img-avatar {
        width: 100px;
        border-radius: 50%;
        width: 63px;
        height: 63px;
        z-index: 2;
      }
      .img-bar {
        transform: rotate(-23deg);
        transition: 0.4s linear;
        z-index: 4;
        position: absolute;
        right: 8px;
        top: -10px;
        width: 35px;
        transform-origin: 8% 8%;
        // transform: rotate(-20deg);
      }
    }
  }
  .avatar-parent {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 75px;
    left: 50%;
    z-index: 3;
    transform: translateX(-50%) translateY(-50%);
  }
  .avatar-cd-parent {
    position: absolute;
    z-index: 2;
  }
</style>
<style>
  .rotate-30-minus {
    transform: rotate(0deg) !important;
  }
</style>
